import React, { ReactNode } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
const defaultProps = {
  level: 1,
  align: 'left',
  className: '',
};
type TitleProps = { children: string | ReactNode } & typeof defaultProps;
export function Title(props: TitleProps) {
  const { className, level, children, align, ...rest } = props;

  switch (level) {
    case 1:
      return (
        <h1
          className={clsx(
            'text-typo-title text-[26px] dark:text-grayscale-lighter',
            className,
            `text-${align}`,
          )}
          {...rest}
        >
          {children}
        </h1>
      );
    case 2:
      return (
        <h2
          className={clsx(
            'text-typo-title text-2xl dark:text-grayscale-lighter',
            className,
          )}
          {...rest}
        >
          {children}
        </h2>
      );
    case 3:
      return (
        <h3
          className={clsx(
            'text-typo-title text-[22px] dark:text-grayscale-lighter',
            className,
          )}
          {...rest}
        >
          {children}
        </h3>
      );
    case 4:
      return (
        <h4
          className={clsx(
            'text-typo-title text-xl dark:text-grayscale-lighter',
            className,
          )}
          {...rest}
        >
          {children}
        </h4>
      );
    case 5:
      return (
        <h5
          className={clsx(
            'text-typo-title text-lg dark:text-grayscale-lighter',
            className,
          )}
          {...rest}
        >
          {children}
        </h5>
      );
    default:
      return null;
  }
}

Title.defaultProps = defaultProps;
Title.propTypes = {
  level: PropTypes.number,
  align: PropTypes.string,
  className: PropTypes.string,
};
